import React, { memo } from 'react';
import { MultilineTextField } from 'app/pages/Survey/Subject/elements';
import { useTextLongAnswer } from './hooks';

const Answer = () => {
  const textLongAnswerConfig = useTextLongAnswer();

  return <MultilineTextField minRows={4} {...textLongAnswerConfig} />;
};

export default memo(Answer);
